import React, { useEffect, useState } from 'react';
import {
  DoNotAskCheckbox,
  IconContainer,
  InstallButton,
  PWADiv,
  PWADNADiv,
  PWADNADivText,
  PWALogo,
  PWALogoDiv,
  StyledPWACard,
  TextInstallButtonContainer,
} from './styles';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getText } from '../../../utils/i18n';

const InstallPWA = (props) => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [cardOpen, setCardOpen] = useState(false);
  const [doNotAsk, setDoNotAsk] = useState(false);
  const { i18n } = props;

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setCardOpen(true);
      setPromptInstall(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('transitionend', handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };

  const closeCard = () => {
    setCardOpen(false);
    document.cookie = 'doNotAsk=' + doNotAsk;
  };

  return (
    <>
      {!supportsPWA || !cardOpen || document.cookie.includes('doNotAsk=true') ? null : (
        <StyledPWACard variant="outlined">
          <IconContainer style>
            <IconButton color="inherit" onClick={closeCard} aria-label="close">
              <CloseIcon />
            </IconButton>
          </IconContainer>
          <PWALogoDiv>
            <PWALogo src={`config/images/AppV4192.png`} alt={'pwaLogo'} />
            <TextInstallButtonContainer>
              {i18n?.installPWA?.message && (
                <PWADiv dangerouslySetInnerHTML={{ __html: i18n.installPWA.message }} />
              )}
              <InstallButton
                className="link-button"
                id="setup_button"
                aria-label="Install app"
                title="Install app"
                onClick={onClick}
              >
                {getText(i18n, 'installPWA.addToHomescreenButton', 'Add Screen')}
              </InstallButton>
            </TextInstallButtonContainer>
          </PWALogoDiv>
          <PWADNADiv>
            <DoNotAskCheckbox
              id="DoNotAskCheckbox"
              value={doNotAsk}
              onChange={(e) => {
                setDoNotAsk(doNotAsk !== true);
              }}
            />
            <PWADNADivText dangerouslySetInnerHTML={{ __html: i18n.installPWA.dnaMessage }} />
          </PWADNADiv>
        </StyledPWACard>
      )}
    </>
  );
};

InstallPWA.propTypes = {
  i18n: PropTypes.object,
};
const mapStateToProps = (state) => ({
  i18n: state.i18nSlice.i18n,
});

export default connect(mapStateToProps)(InstallPWA);
